import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import InviteUserModal from '@common-components/invite/InviteUserModal';
import { ExtraDataPanel } from '@common-components/tasks/extraData/ExtraDataPanel';
import ActivityLog from '@common-components/tasks/extraData/logs/activity-log';
import NotificationsDrawer from '@common-components/tasks/extraData/notifications/notifications-drawers';
import { setExtraDataOfTaskId } from '@common-reducers/ExtraDataReducer';
import { updateAllUnseenNotificationsToSeenThunk } from "@common-reducers/NotificationsSelectors";
import { taskActions } from '@common-reducers/TasksReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import classes from "./tasks-panel.module.scss";

const TasksPanelDrawerContent = () => {
    const dispatch = useAppDispatch();
    const taskViewSideDrawerOpen = useAppSelector(
        (state) => state.TasksReducer.taskViewSideDrawerOpen
    );
    const direction = useAppSelector((state) => state.UserReducer.direction);
    const isExtraDataPanel = taskViewSideDrawerOpen === "ExtraDataPanel";

    function closeTaskViewSideDrawer(taskViewSideDrawerOpen: string) {
        dispatch(taskActions.setTaskViewSideDrawerOpenWith(""));
        if (taskViewSideDrawerOpen === 'ExtraDataPanel') {
            let url = new URL(window.location.href);
            url.searchParams.delete('taskId');
            url.searchParams.delete('updateId');
            window.history.pushState({ path: url.toString() }, '', url.toString());
            dispatch(setExtraDataOfTaskId(''))
        }
        if (taskViewSideDrawerOpen === 'notificationsDrawer') {
            dispatch(updateAllUnseenNotificationsToSeenThunk())
        }
    }

    return (
        <div
            dir={direction}
            style={{
                background: taskViewSideDrawerOpen === "ExtraDataPanel" || taskViewSideDrawerOpen === "Help" ? "var(--color-surface)" : "var(--tasks-group-bg)",
                padding: taskViewSideDrawerOpen === "ExtraDataPanel" || taskViewSideDrawerOpen === "Help" ? "0" : "0 20px",
                height: isExtraDataPanel ? "100%" : undefined,
                display: isExtraDataPanel ? "flex" : undefined,
                flexDirection: isExtraDataPanel ? "column" : undefined,
                overflow: isExtraDataPanel ? "hidden" : undefined,
            }}
        >
            <div
                style={{
                    background: taskViewSideDrawerOpen === "ExtraDataPanel" || taskViewSideDrawerOpen === "Help" ? "var(--color-surface)" : "var(--tasks-group-bg)"
                }}
                className={classes.header}
            >
                <IconButton
                    sx={{ marginInlineStart: taskViewSideDrawerOpen === "ExtraDataPanel" ? "25px" : 0 }}
                    onClick={() => closeTaskViewSideDrawer(taskViewSideDrawerOpen ?? '')}
                >
                    <Close />
                </IconButton>
            </div>

            {taskViewSideDrawerOpen === "ExtraDataPanel" && (
                <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                    <ExtraDataPanel />
                </div>
            )}
            {taskViewSideDrawerOpen === "InviteUserModal" && <InviteUserModal />}
            {taskViewSideDrawerOpen === "ActivityLog" && <ActivityLog />}
            {taskViewSideDrawerOpen === 'notificationsDrawer' && <NotificationsDrawer />}
        </div>
    );
};

export default TasksPanelDrawerContent;
